"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeProjectCustomer = void 0;
const redux_observable_1 = require("redux-observable");
const ActionTypes = require("../../actionTypes/project/change");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Actions = require("../../actions/project/change");
const errorHandling_1 = require("../../utils/errorHandling");
const changeProjectCustomer = (action$, store, { ajax, getToken, baseUrl }) => {
    const getUrl = () => {
        return `${baseUrl}api/admin/project/customer`;
    };
    const ajaxOptions = (action) => {
        return {
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            url: getUrl(),
            body: action.payload
        };
    };
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.CHANGE_CUSTOMER_REQUEST), (0, operators_1.mergeMap)((action) => ajax(ajaxOptions(action)).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.changeCustomerSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.changeCustomerFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
};
exports.changeProjectCustomer = changeProjectCustomer;
//# sourceMappingURL=change.js.map